
import { trackStickyFooterRegisterClick } from '@marketplace/helpers/segment/index.js'
import { mapGetters } from 'vuex'

export default {
    name: 'NotificationFooterForUnregistered',

    data() {
        return {
            shouldHideOnMobile: true,
        }
    },

    computed: {
        ...mapGetters('global', ['showElementAfterTreshold']),

        canBeToggled() {
            return this.$breakpoint.includes('mobile')
        },
        isHidden() {
            if (this.canBeToggled) return !this.showElementAfterTreshold

            return false
        },
    },

    methods: {
        signUp() {
            trackStickyFooterRegisterClick()
            this.$showSignupModal()
        },
    },
}
